import { ThemeProvider, createTheme, CssBaseline } from '@mui/material'
import { modellingTheme } from 'Common/Supplyvue-ui'

export const AppThemeProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const theme = createTheme(modellingTheme)
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
